module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/01-742306c6afecf27ae9f401e00bd10df2.jpg";